import React, {useEffect, useState} from 'react'
import {Button, Header, Message, Modal} from 'semantic-ui-react'

const Error = (
  {
    error,
    onClose
  }
) => {
  const [visible, setVisible] = useState(true)
  const hide = () => {
    setVisible(false)
  }
  onClose = onClose || hide

  useEffect(() => {
    if (!visible) {
      setVisible(true)
    }
  }, [error])

  if (error) {
    let details = error.details
    if (!details && error.response && error.response.data) {
      details = error.response.data
    }
    if (!details && error.data) {
      details = error.data
    }
    return (
      <Modal open={visible} closeOnDimmerClick={true} closeIcon={true} onClose={onClose} style={{width: '75vw'}}>
        <Modal.Content scrolling>
          <Message error>
            <Message.Header>Oops - An error occurred!</Message.Header>
            {
              error.message && (
                <>
                  <Header as='h4' style={{marginTop: '15px'}}>Message</Header><p>
                  {
                    error.message
                  }
                </p>
                </>
              )
            }
            {
              details && (
                <>
                  <Header as='h4' style={{marginTop: '15px'}}>Details</Header>
                  <pre className='pre-wrap'>
                        {
                          JSON.stringify(details, null, 2).replace(/\\n/g, '')
                        }
                    </pre>
                </>
              )
            }
          </Message>
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={onClose}>Close</Button>
        </Modal.Actions>
      </Modal>
    )
  }
  return (<></>)
}

export {Error}

export default Error